<template>
    <div class="bg" :style="{
        'background': `url(${config.bgImageUrl}) no-repeat center/cover`,
        'backgroundColor': '#f5f5f5' // 添加备用背景色
    }">
        <div>
            <img src="../assets/img/ba.png" alt="" class="back" @click="back">
        </div>
        <div class="logo_wrap flex_center">
            <img class="logo" :src="config.logoTopImg" alt="" :style="{ 'height': config.logoTopHeight + 'px' }">
            <div class="logo_right">
                <div class="power">{{ $t('PoweredbyMVGX') }}</div>
                <!-- <div class="right_top_txt_shu">|</div>
        <Kefu :sn="sn"></Kefu> -->
            </div>
        </div>


        <!-- <div class="logo_wrap customer">
      Thank you for contacting Customer Service.
    </div> -->
        <div class="logo_wrap  refer">
            {{ $t('Pleasesubmiyourquery') }}
        </div>
        <div class="einput">
            <el-input :placeholder="$t('SerialNo')" v-model="form.sn" disabled></el-input>
        </div>
        <div class="einput" v-if="form.eventName">
            <el-input :placeholder="$t('EventName')" v-model="form.eventName" disabled></el-input>
        </div>
        <div class="einput">
            <el-input :placeholder="$t('FullName')" v-model="form.fullName"></el-input>
        </div>
        <div class="einput">
            <el-input :placeholder="$t('ContactNumber')" v-model="form.concatNumber" type="number"></el-input>
        </div>
        <div class="einput flex_c">
            <el-input :placeholder="$t('Email')" v-model="form.email"></el-input>
            <div class="reply">{{ $t('Ifrequirereply') }}</div>
        </div>
        <div class="einput etextarea">
            <div><img src="../assets/img/mi.png" alt="" class="mi"></div>
            <el-input type="textarea" :rows="5" resize="none" v-model="form.question"
            :placeholder="$t('abriefdescription')">
            </el-input>
        </div>
        <div class="einput send" @click="send">{{ $t('Send') }}</div>
        <div class="our">{{ $t('Wewillreplywithi') }}</div>
        <!-- <div class="our">Thank You.<br> Head, Customer Service.</div> -->
        <div class="divider"><el-divider></el-divider></div>

        <div class="informed ">{{ $t('Pleasebeinformedour') }}</div>

        <el-dialog :show-close="false" :visible.sync="dialogVisible" width="80%" style="margin-top:0" :center="true"
            top="'0'" :modal="false" class="thisblack-bgc" :close-on-click-modal="false">
            <div style="text-align:center">
                <img src="../assets/img/succes.png" alt="" class="success">
                <div class="text">{{ $t('SubmitSuccessful') }}</div>
                <div class="confirm" @click="confirm">{{ $t('Confirm') }}</div>
            </div>
        </el-dialog>

        <el-dialog title="" :visible.sync="emailShow" :close-on-click-modal="false" width="95%" :show-close="false"
            :top="'0'" center>
            <div>Please enter the correct email address</div>
            <span slot="footer" class="dialog-footer">
                <div class="btn_cancel" @click="emailShow = false">{{ $t('Close') }}</div>
            </span>
        </el-dialog>

        <el-dialog title="" :visible.sync="questionShow" :close-on-click-modal="false" width="95%" :show-close="false"
            :top="'0'" center>
            <div>{{ $t('Pleaseenterthequestion') }}</div>
            <span slot="footer" class="dialog-footer">
                <div class="btn_cancel" @click="questionShow = false">{{ $t('Close') }}</div>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import cnt from "@/api/cnt";
import Kefu from '@/components/kefu.vue'
export default {
    components: { Kefu },
    data() {
        return {
            sn: "",
            dialogVisible: false,
            emailShow: false,
            questionShow: false,
            form: {
                sn: this.$route.query.sn,
                eventName: '',
                fullName: '',
                concatNumber: '',
                email: '',
                question: ''
            },
            config: '',
        };
    },
    created() {
        this.sn = this.$route.query.sn;
        this.form.sn = this.$route.query.sn;
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
        // this.sn = this.$route.query.sn;
        // this.getTravelRecord()
        // this.getUserEvent(1,1)
    },
    mounted() {
        // this.sn = this.$route.query.sn;
        let userinfo = JSON.parse(sessionStorage.getItem('activityInfo'))
        this.form.eventName = userinfo.activityName
    },
    methods: {
        //用户行为分析
        getUserEvent(val, type) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
            }
            cnt.getUserEvent(res => {
                console.log(res)
            }, params)
        },
        back() {
            this.$router.go(-1)
        },
        send() {
            if (this.form.email && this.form.email.indexOf("@") == -1) {
                this.emailShow = true
                return
            } else if (!this.form.question) {
                this.questionShow = true
                return
            }
            cnt.getSendDoubtEmail(res => {
                if (res.code == 200) {
                    this.dialogVisible = true
                } if (res.code == 500) {
                    this.$message.error(res.message)
                }
            }, this.form)
        },
        tab(index) {
            if (index == 1) {
                var data = {
                    sn: this.sn,
                    operationName: this.Digital,
                };
            } else if (index == 2) {
                var data = {
                    sn: this.sn,
                    operationName: this.World,
                };
            }
            cnt.getWelcome((res) => {
                if (res.id == 1) {
                    this.$router.push({ path: "/trip", query: { sn: this.sn } });
                } else if (res.id == -2) {
                    // this.$message.error('Serial number does not exist')
                    this.$message.error(this.$t('Sorrythecodelinked'))
                }
            }, data);
        },
        getTravelRecord() {
            cnt.getTravelRecord(
                (res) => {
                    if (!res) {
                        this.$router.push({ path: "/result", query: { sn: this.sn } });
                    } else if (res.snStatus == 1) {
                        this.$router.push({ path: "/info", query: { sn: this.sn } });
                    } else if (res.snStatus == 2) {
                        this.$router.push({ path: "/resultCard", query: { sn: this.sn } });
                    } else if (res.snStatus == null) {
                        if (res.operationName == null) {
                            this.$router.push({ path: '/welcome', query: { sn: this.sn } })
                        } else {
                            this.$router.push({ path: '/trip', query: { sn: this.sn } })
                        }
                    }
                },
                { sn: this.sn }
            );
        },
        helpDetail(item) {
            this.$router.push("/helpDetail")
            sessionStorage.setItem('detail', JSON.stringify(item))
        },
        confirm() {
            this.dialogVisible = false
            this.form.fullName = ''
            this.form.concatNumber = ''
            this.form.email = ''
            this.form.question = ''
        }
    },
};
</script>
<style lang='less' scoped>
.bg {
    width: 100%;
    // height: 100%;
    // position: fixed;
    // top: 0;
    // left: 0;
    min-height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.back {
    width: .8125rem;
    height: 1.375rem;
    margin: 2.5rem 1.25rem 0;
}

.logo {
    width: auto;
}

.power {
    font-size: .75rem;
    font-family: Century Gothic;
    color: #EDFFFE;
}

.flex_center {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.flex_c {
    display: flex;
    align-items: center;
}

.logo_wrap {
    margin: 1.25rem 1.25rem 2.1875rem;
}

.logo_right {
    display: flex;
}

.right_top_txt_shu {
    margin: 0 12px;
    color: #EDFFFE;
}

.bangzhu {
    width: 17px;
    height: 17px;
}

.customer {
    color: #FFFFFF;
    font-size: 1.6875rem;
    font-weight: bold;
}

.refer {
    color: #FFFFFF;
    font-size: .75rem;
    line-height: 1.25rem;
}

.einput {
    margin: 0 1.25rem .9375rem;
    background: #ffffff;
    border-radius: .625rem;

    ::v-deep .el-input__inner {
        border-radius: .625rem;
        border: none;
        outline: none;
        color: #1e1e1e;
    }

    .reply {
        width: 7.5rem;
        font-size: 12px;
        color: #C1C1C1;
    }

    .mi {
        width: .375rem;
        height: .3125rem;
        margin-bottom: .3125rem;
    }

}

.etextarea {
    padding: .9375rem;

    ::v-deep .el-textarea__inner {
        border: none;
        background-color: #E6F0F2;
        color: #1e1e1e;
    }
}

.send {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2.8125rem;
    color: #4D94A0;
    font-size: .9375rem;
    margin: 2.125rem 1.25rem 2.0625rem;
    cursor: pointer;
}

.our {
    font-size: .75rem;
    color: #ffffff;
    margin: 0 1.25rem .625rem;
}

.informed {
    text-align: center;
    font-size: .75rem;
    color: #ffffff;
    padding: 0 1.25rem 2.1875rem;
}

.divider {
    margin: 0 1.25rem;
}

::v-deep .el-dialog {
    height: 13.4375rem;
    border-radius: .625rem;
    position: fixed;
    margin: 0;
    top: 50%;
    left: 50%;
    margin-top: 0;
    text-align: center;
    transform: translate(-50%, -50%);

    .success {
        width: 2.1875rem;
        height: 1.5625rem;
        margin-bottom: .9375rem;
    }

    .text {
        font-size: .9375rem;
        margin-bottom: 1.875rem;
    }

    .confirm {

        width: 8.1875rem;
        height: 2.8125rem;
        background: linear-gradient(90deg, #6CB1CC 0%, #59C798 100%);
        box-shadow: 0px .1875rem .375rem 0px rgba(0, 98, 76, 0.22);
        border-radius: .625rem;
        font-size: .9375rem;
        font-family: Century Gothic;
        color: #FFFFFF;
        line-height: 2.8125rem;
        text-align: center;
        margin-left: 50%;
        transform: translate(-50%, 0);
    }
}

.thisblack-bgc {
    background-color: rgba(0, 0, 0, 0.5);
}

::v-deep .el-input.is-disabled .el-input__inner {
    color: #1e1e1e;
}

::v-deep .el-dialog {
    background: #FFFFFF;
    border-radius: 20px;

    .el-dialog__title {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #303236;
        line-height: 25px;
    }

    .el-dialog__body {
        font-size: 15px;
        font-family: Century Gothic;
        color: #8F8F8F;
        line-height: 20px;
        text-align: center;
        padding: 1.5625rem .875rem 1.875rem !important;
    }

    .dialog-footer {
        display: flex;
        justify-content: center;

        .btn_cancel {
            width: 131px;
            height: 45px;
            box-shadow: 0px 2.5008px 6px 0px rgba(0, 98, 76, 0.22);
            border-radius: 10px;
            border: 1px solid;
            border-color: linear-gradient(90deg, rgba(107, 179, 201, 1), rgba(90, 198, 153, 1)) 1 1;
            font-size: 15px;
            font-family: Century Gothic;
            color: #4D94A0;
            line-height: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-right: 10px;
        }

        .btn_confirm {
            width: 131px;
            height: 47px;
            background: linear-gradient(90deg, #6CB1CC 0%, #59C798 100%);
            box-shadow: 0px 2.5008px 6px 0px rgba(0, 98, 76, 0.22);
            border-radius: 10px;
            font-size: 15px;
            font-family: Century Gothic;
            color: #FFFFFF;
            line-height: 17px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-left: 10px;
        }
    }
}
</style>
